import React, { useEffect } from "react";
import { INGContextProvider } from "./Context";
import CustomFilter from "./FilterING/CustomFilter";
import TableING from "./IngReportTable/TableING";
import { loggingApiING } from "./ingService";

const INGHomePage = () => {
  useEffect(() => {
    loggingApiING();
  }, []);

  return (
    <INGContextProvider>
      <div className="container-fluid">
        <CustomFilter />
        <TableING />
      </div>
    </INGContextProvider>
  );
};

export default INGHomePage;
